import styled from "styled-components";

export const StyledMenuModal = styled.div`
    position: absolute;
    min-width: 220px;
    top: 100px;
    right: 8px;
    background-color: white;
    border-radius: 12px;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.05);
    padding: 8px;
    z-index:9999;

    & ::after {
        content: "";
        position: absolute;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid white;
        right: 18px;
        top: -13px;
    }
`